import 'url-search-params-polyfill';

import React from 'react';
import { createRoot } from 'react-dom/client';
import routes from './routes';
import { BrowserRouter } from 'react-router-dom';
import ThemeProvider from 'providers/ThemeProvider';
import 'utils/i18n';
import './assets/css/index.css';
import 'moment/locale/ro';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { AreasWrapper } from './providers/AreasProvider';
import AuthApolloProvider from 'apollo/AuthApolloProvider';
import AuthProvider from 'providers/AuthenticationProvider';
import LogoutProvider from 'providers/LogoutProvider';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <AuthProvider>
    <AreasWrapper>
      <AuthApolloProvider>
        <ThemeProvider>
          <LogoutProvider>
            <BrowserRouter>{routes}</BrowserRouter>
          </LogoutProvider>
        </ThemeProvider>
      </AuthApolloProvider>
    </AreasWrapper>
  </AuthProvider>
);
